export default __webpack_public_path__ + "static/media/bad.21550869.svg";